import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ArticleViewer.css";
import { apiFetch } from "../utils/apifetch";
import { useAuth } from "../App";

const buildFileUrl = (path) => {
  if (!path) return null;
  const normalized = path.replace(/\\/g, "/").replace(/^\/+/, "");
  const baseUrl = import.meta.env.VITE_API_URL.replace(/\/api\/?$/, "");
  return `${baseUrl}/${normalized}`;
};

export default function ArticleViewer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const res = await apiFetch(`/article/${id}`, {}, logout, navigate);
        const data = await res.json();
        setArticle(data);
      } catch {
        setError("Unable to load article");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id, logout, navigate]);

  if (loading) return <div className="profile-loading">Loading article…</div>;
  if (error) return <div className="profile-error">{error}</div>;
  if (!article) return null;

  const pdfUrl = buildFileUrl(article.ArticlePdfPath);

  return (
    <div className="article-viewer">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {/* ===== AUTHOR ===== */}
      <div className="subtitle-1">Author Title and Name:</div>
      {article.AuthorTitle && (
        <p className="subtitle-1">{article.AuthorTitle}</p>
      )}
      <h4>
        {article.AuthorName}
        {article.AuthorInitial ? ` ${article.AuthorInitial}` : ""}
      </h4>

      {/* ===== TITLE (PHASE 1) ===== */}
      <div className="subtitle-1">Article Title:</div>
    
        <div className="article-viewer-description">
          {article.ShortDescription}
        </div>
   

      {/* ===== CREATED DATE ===== */}
      <div className="subtitle-1">Created on:</div>
      <div className="article-viewer-description">
        {article.CreatedAt
          ? new Date(article.CreatedAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "-"}
      </div>

      {/* ===== EMBEDDED PDF (PHASE 2) ===== */}
      <div className="article-pdf-container">
        {pdfUrl ? (
          <>
            <div className="pdf-toolbar">📄 Article PDF</div>
            <iframe
              src={pdfUrl}
              title="Article PDF"
              loading="lazy"
            />
          </>
        ) : (
          <div className="no-pdf">No Article PDF uploaded</div>
        )}
      </div>
    </div>
  );
}
